import { es } from './es';
import { ca } from './ca';
import { gl } from './gl';
import { eu } from './eu';

export type Language = 'es' | 'ca' | 'gl' | 'eu';

export interface LanguageOption {
  code: Language;
  name: string;
  nativeName: string;
  flag: string;
  shortCode: string;
}

export const AVAILABLE_LANGUAGES: LanguageOption[] = [
  { code: 'es', name: 'Español', nativeName: 'Español', flag: '🇪🇸', shortCode: 'ES' },
  { code: 'ca', name: 'Catalán', nativeName: 'Català', flag: '🏴󠁥󠁳󠁣󠁴󠁿', shortCode: 'CA' },
  { code: 'gl', name: 'Gallego', nativeName: 'Galego', flag: '🏴󠁥󠁳󠁧󠁡󠁿', shortCode: 'GL' },
  { code: 'eu', name: 'Vasco', nativeName: 'Euskara', flag: '🏴󠁥󠁳󠁰󠁶󠁿', shortCode: 'EU' },
];

export const TRANSLATIONS: Record<Language, Record<string, string>> = {
  es,
  ca,
  gl,
  eu,
};
